import React, { useState } from "react";
import Modal from "../common_modal/Modal";

export default function C_E_USER({ config, onClose, inPopup = false }) {
  const [showPopupModal, setShowPopupModal] = useState(false);

  const { row, field } = config;
  const user = row?.user;
  const updated_by = row?.updated_by;

  const value = row?.properties?.[field.key];

  let final_user;

  if (field?.type === "auto_generate_user_name") {
    final_user = user;
  } else {
    final_user = updated_by;
  }

  const displayName = final_user?.full_name || final_user?.name || value;

  if (!final_user && !value) return null;

  // --- REUSABLE RICH CONTENT ---
  const largeAvatar =
    final_user?.profile_picture?.url ||
    final_user?.profile_picture?.url_compressed;

  const userDetailsContent = (
    <div
      className="box-body"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "19px",
        gap: "16px",
        fontFamily: "sans-serif",
      }}
    >
      {largeAvatar ? (
        <img
          src={largeAvatar}
          alt={displayName}
          style={{
            width: "131px",
            height: "131px",
            borderRadius: "50%",
            objectFit: "cover",
            border: "3px solid #f3f4f6",
            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
          }}
        />
      ) : (
        <div
          style={{
            width: "131px",
            height: "131px",
            borderRadius: "50%",
            backgroundColor: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "32px",
            color: "#9ca3af",
            fontWeight: "bold",
          }}
        >
          {displayName?.charAt(0)?.toUpperCase()}
        </div>
      )}

      {/* User Names */}
      <div style={{ textAlign: "center" }}>
        <h3
          style={{
            margin: "0 0 4px 0",
            fontSize: "20px",
            color: "#111827",
          }}
        >
          {final_user?.full_name || final_user?.name || "Unknown User"}
        </h3>
        {final_user?.name && (
          <p style={{ margin: 0, fontSize: "14px", color: "#6b7280" }}>
            @{final_user.name}
          </p>
        )}
      </div>

      {/* User Details List */}
      <div
        style={{
          width: "100%",
          borderTop: "1px solid #e5e7eb",
          paddingTop: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        {final_user?.email && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: "14px",
            }}
          >
            <span style={{ color: "#6b7280" }}>Email</span>
            <span style={{ color: "#111827", fontWeight: 500 }}>
              {final_user.email}
            </span>
          </div>
        )}

        {final_user?.phone_number && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: "14px",
            }}
          >
            <span style={{ color: "#6b7280" }}>Phone</span>
            <span style={{ color: "#111827", fontWeight: 500 }}>
              {final_user.phone_number}
            </span>
          </div>
        )}

        {final_user?.badge && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontSize: "14px",
            }}
          >
            <span style={{ color: "#6b7280" }}>Badge</span>
            <span
              style={{
                padding: "4px 10px",
                backgroundColor: "#e0f2fe",
                color: "#0369a1",
                borderRadius: "12px",
                fontSize: "12px",
                fontWeight: 600,
                textTransform: "capitalize",
              }}
            >
              {final_user.badge}
            </span>
          </div>
        )}
      </div>
    </div>
  );

  // 1. POPUP MODE (Simplified Visual + Click to open Modal)
  if (inPopup) {
    const smallAvatar =
      final_user?.profile_picture?.url_compressed ||
      final_user?.profile_picture?.url;

    return (
      <>
        <div
          onClick={(e) => {
            e.stopPropagation();
            setShowPopupModal(true);
          }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            cursor: "pointer", // Added pointer to indicate clickability
          }}
          title={displayName}
        >
          {smallAvatar ? (
            <img
              src={smallAvatar}
              alt={displayName}
              style={{
                width: "19px",
                height: "19px",
                borderRadius: "50%",
                objectFit: "cover",
                flexShrink: 0,
                border: "1px solid #e5e7eb",
              }}
            />
          ) : (
            <div
              style={{
                width: "19px",
                height: "19px",
                borderRadius: "50%",
                backgroundColor: "#f3f4f6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "10px",
                fontWeight: "bold",
                color: "#6b7280",
                flexShrink: 0,
              }}
            >
              {displayName?.charAt(0)?.toUpperCase() || "?"}
            </div>
          )}

          <span
            style={{
              display: "block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
              lineHeight: "1.5",
            }}
          >
            {displayName}
          </span>
        </div>

        {/* Modal triggered strictly by the popup simplified visual */}
        {showPopupModal && (
          <Modal
            modalSize="small"
            id={`modal-user-${final_user?._id || "unknown"}-popup`}
            isOpen={true}
            onClose={(e) => {
              if (e) e.stopPropagation();
              setShowPopupModal(false);
            }}
            title="User detail"
          >
            {userDetailsContent}
          </Modal>
        )}
      </>
    );
  }

  // 2. STANDARD MODE (Rich Visual directly inside Modal)
  return (
    <Modal
      modalSize="small"
      id={`modal-user-${final_user?._id || "unknown"}`}
      isOpen={true}
      onClose={onClose}
      title="User detail"
    >
      {userDetailsContent}
    </Modal>
  );
}
